import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { MRT_Localization_DA } from 'material-react-table/locales/da';

/**
 * Load correct language pack for Material React Table based on the document language.
 * @returns directly prepared and ready language pack for Material React Table
 */
export function getLocalizedLanguagePack() {
  if ( document.documentElement.lang === 'da') { // AU sites define lang as either 'en' or 'da'
    return MRT_Localization_DA;
  } else { // Default to English
    return MRT_Localization_EN;
  }
}

/**
 * Get the modal dialog title based on the document language.
 * @returns localized dialog title
 */
export function getDialogTitle() {
  if ( document.documentElement.lang === 'da') { // AU sites define lang as either 'en' or 'da'
    return 'Detaljer';
  } else { // Default to English
    return 'Details';
  }
}
